
    import { Component, Vue } from 'vue-property-decorator';
    import { mapActions, mapMutations, mapState } from 'vuex';
    import TerminartenDetail from '@/components/Terminarten/TerminartenDetail.vue';
    import { LoadTerminartenPayload, SetTerminartenDialogs, TerminartenFilter } from '@/store/terminarten';
    import { DataTableHeaders } from '@/types';
    import Terminart from '@/types/Terminart';

    @Component({
        components: {
            TerminartenDetail,
        },
        methods: {
            ...mapActions('terminarten', ['loadTerminarten']),
            ...mapMutations('terminarten', ['setDialogs']),
        },
        computed: {
            ...mapState('terminarten', ['terminarten', 'dialogs', 'loaders']),
        },
    })
    export default class Terminarten extends Vue {
        public loadTerminarten!: (payload?: LoadTerminartenPayload) => void;
        public setDialogs!: (payload: SetTerminartenDialogs) => void;

        public terminart = new Terminart();
        public search = '';

        public filter: TerminartenFilter = {
            gueltig: 'j',
        };

        public get headers(): DataTableHeaders<Terminart> {
            return [
                { text: '', value: 'actions', sortable: false, width: 50 },
                { text: 'Terminart', value: 'bezeichnung' },
                { text: 'Farbe', value: 'color' },
                { text: 'Schriftfarbe', value: 'textcolor' },
                { text: 'Gültig', value: 'gueltig' },
                { text: 'Standard', value: 'standard' },
            ];
        }

        public colorSwatchStyle(terminart: Terminart): Partial<CSSStyleDeclaration> {
            return {
                backgroundColor: terminart.color as string,
                height: '30px',
                width: '30px',
                borderRadius: '4px',
                border: '0.1pt solid black',
                transition: 'border-radius 200ms ease-in-out',
                marginBottom: '3px',
            };
        }

        public colorTextSwatchStyle(terminart: Terminart): Partial<CSSStyleDeclaration> {
            return {
                backgroundColor: terminart.textcolor as string,
                height: '30px',
                width: '30px',
                borderRadius: '4px',
                border: '0.1pt solid black',
                transition: 'border-radius 200ms ease-in-out',
                marginBottom: '3px',
            };
        }

        public mounted(): void {
            this.loadTerminarten({ filter: this.filter });
        }

        public onChangeFilter(): void {
            this.loadTerminarten({ filter: this.filter });
        }

        public onClickEditTerminart(terminart: Terminart): void {
            this.terminart = new Terminart(terminart);
            this.setDialogs({ edit: true });
        }

        public onClickNewTerminart(): void {
            this.terminart = new Terminart();
            this.setDialogs({ edit: true });
        }
    }
